import type { BoostingPack } from '~/config'

export type CurrencyKind = 'cookies' | 'coins' | 'gems'

export type CurrencyReward = { kind: CurrencyKind; amount: number }

// Boosting Pack rewards are granted server-side as three currencies at once.
// The queue shows them one at a time in this fixed order (cookies, coins, gems)
// — matching the top-nav pill order — and skips any zero-amount grant so the
// "n/total" counter only ever counts prizes the user actually sees.
export function toCurrencyRewards(
  rewards: BoostingPack['rewards'],
): CurrencyReward[] {
  return (
    [
      { kind: 'cookies', amount: rewards.cookies },
      { kind: 'coins', amount: rewards.coins },
      { kind: 'gems', amount: rewards.gems },
    ] satisfies CurrencyReward[]
  ).filter((reward) => reward.amount > 0)
}
